export const createPermissionMap = (navData) => {
    const permissionMap = {};
    
    navData.forEach(item => {
        permissionMap[item.link] = {
            web: item.web,
            view: item.view,
            create: item.create,
            edit: item.edit,
            delete: item.delete
        };
        
        // Add children permissions
        if (item.childs && item.childs.length > 0) {
            item.childs.forEach(child => {
                permissionMap[child.link] = {
                    web: child.web,
                    view: child.view,
                    create: child.create,
                    edit: child.edit,
                    delete: child.delete
                };
            });
        }
    });
    
    return permissionMap;
};